const availableCastingJobTypes = [
    {
        label: 'Recepcionista',
        code: 'receptionist'
    },
    {
        label: 'Recepcionista bilingue INGLÊS',
        code: 'receptionist_english'
    },
    {
        label: 'Recepcionista bilingue ESPANHOL',
        code: 'receptionist_spanish'
    },
    {
        label: 'Promotor(a)',
        code: 'promoter'
    },
    {
        label: 'Credenciamento/Portaria/Validador',
        code: 'accreditation'
    },
    {
        label: 'Supervisão/Coordenação de Casting',
        code: 'casting_supervisor'
    },
    {
        label: 'Modelo para Lookbook',
        code: 'lookbook_model'
    }
]

const availableEventSupportJobTypes = [
    {
        label: 'Coordenação e Produção de Eventos',
        code: 'coordination_production'
    },
    {
        label: 'Apoio Operacional/Assistente de Produção',
        code: 'operational_support'
    },
    {
        label: 'Carregador',
        code: 'carrier'
    },
    {
        label: 'Limpeza',
        code: 'cleaning'
    },
    {
        label: 'Intérprete de Libras',
        code: 'asl_interpreter'
    },
    {
        label: 'Moderador para Evento Online',
        code: 'online_event_staff'
    }
]

const availableBarsRestaurantsJobTypes = [
    {
        label: 'Bartender',
        code: 'bartender'
    },
    {
        label: 'Garçom/garçonete',
        code: 'waiter'
    },
    {
        label: 'Hostess',
        code: 'hostess'
    },
    {
        label: 'Cozinheiro(a)',
        code: 'chef'
    }
]

const availableMasterOfCeremoniesJobTypes = [
    {
        label: 'Mestre de Cerimônias presencial',
        code: 'master_of_ceremonies_in_person'
    },
    {
        label: 'Mestre de Cerimônias digital',
        code: 'digital_master_of_ceremonies'
    },
    {
        label: 'Celebrante',
        code: 'celebrant'
    }
]

export {
    availableCastingJobTypes,
    availableEventSupportJobTypes,
    availableBarsRestaurantsJobTypes,
    availableMasterOfCeremoniesJobTypes
}
